/* eslint-disable */
export default {
  title: 'Áudio',
  dialButtonVolume: 'Volume do botão de marcação',
  ringtoneVolume: 'Volume do toque',
  callVolume: 'Volume da chamada',
  muteCalls: 'Desativar som das chamadas',
  outputDevice: 'Dispositivo de saída',
  inputDevice: 'Dispositivo de entrada',
  micPermission: 'Permissão do microfone',
  noDevice: 'Nenhum dispositivo',
  checkMicPermission: 'Verifique a permissão',
  micNoPermissionMessage:
    'A aplicação não tem permissão para utilizar o microfone',
  noLabel: 'Dispositivo desconhecido',
  notSetSinkIdTip:
    'Lamentamos, mas as permissões atuais do browser não estão definidas para permitir o acesso aos dispositivos de saída de áudio. {clickHereLink} para saber como configurar.',
  noLabelTip:
    'Lamentamos, mas as permissões atuais do browser não estão definidas para permitir o acesso aos dispositivos de entrada de áudio.',
  clickHere: 'Clique aqui',
  defaultOutputDevice: 'Dispositivo de saída predefinido',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
